import * as React from 'react';
import classNames from 'classnames';
import { Banner } from '@grandvisionhq/content';
import { Heading, Text } from '@grandvisionhq/elements';
import '../containers/Accordion/Accordion.js';
import '../containers/Article/Article.js';
import '../containers/ArticleCollection/ArticleCollection.js';
import '../containers/Banner/Banner.js';
import '../containers/BannerCollection/BannerCollection.js';
import '../containers/BlogCollection/BlogCollection.js';
import '../containers/BlogOverview/BlogOverview.js';
import '../containers/BrandCollection/BrandCollection.js';
import '../containers/BrandList/BrandList.js';
import '../containers/Carousel/Carousel.js';
import '@bloomreach/react-sdk';
import CmsContentBlocks from '../containers/ContentBlocks/ContentBlocks.js';
import { CmsContentBreadcrumbs } from '../containers/Breadcrumbs/ContentBreadcrumbs/ContentBreadcrumbs.js';
import '../containers/CountdownTimer/CountdownTimer.js';
import '../containers/Document/Document.js';
import '../containers/Faq/Faq.js';
import '@swc/helpers';
import '@grandvisionhq/layout';
import '../context/configuration.js';
import '@grandvisionhq/state';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { parseBloomreachImage } from '../utils/parse-bloomreach-image.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../hooks/use-breakpoint-visibility.js';
import '../containers/GroupedCards/GroupedCards.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/auth';
import '@grandvisionhq/frk-routing';
import '../containers/Heading/Heading.js';
import '../containers/IconList/IconList.js';
import '../containers/Iframe/Iframe.js';
import '../containers/LinkList/LinkList.js';
import '../containers/Newsletter/Newsletter.js';
import '../containers/NewsletterBanner/NewsletterBanner.js';
import '../containers/TryInStoreBanner/TryInStoreBanner.js';
import '../containers/NotificationBar/NotificationBar.js';
import '../containers/PolicyBar/PolicyBar.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/products';
import '../containers/Breadcrumbs/Breadcrumbs.js';
import '../containers/ProductCatalog/ProductCatalog.js';
import '../containers/Promotion/Promotion.js';
import '../containers/RecentlyViewedProducts/RecentlyViewedProducts.js';
import '../containers/RichText/RichText.js';
import '../containers/Video/Video.js';
import '../containers/Widget/Widget.js';
import '../containers/WidgetTrustedShop/WidgetTrustedShop.js';
import '../containers/Whitespace/Whitespace.js';
import '../containers/SpotlightedStores/SpotlightedStores.js';
import '../containers/FixedCta/FixedCta.js';
import '../containers/Button/Button.js';
import '../containers/GlobalContactForm/GlobalContactForm.js';
import '../containers/RowComponent/RowText/RowText.js';
import '../containers/RowComponent/RowProductListBySku/RowProductListBySku.js';
import { withEditableContent } from '../hocs/with-editable-content.js';

const CmsContentLayout = ({ content , pageName , hasBreadcrumbs  })=>{
    const { contentBlocks , coverImage , summary , title , url  } = content;
    const image = parseBloomreachImage(coverImage);
    const isBrandPage = pageName === 'brand-detail';
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames('content-layout', {
            'content-layout--brand': isBrandPage
        })
    }, hasBreadcrumbs && /*#__PURE__*/ React.createElement(CmsContentBreadcrumbs, {
        url: url
    }), image && /*#__PURE__*/ React.createElement(Banner, {
        useContainer: true,
        image: image.original,
        mobileImage: image.mobile
    }), title && /*#__PURE__*/ React.createElement(Heading, {
        variant: "large",
        className: "content-layout__title",
        align: isBrandPage ? 'center' : 'left'
    }, title), summary && /*#__PURE__*/ React.createElement("div", {
        className: "content-layout__summary rich-text-area"
    }, /*#__PURE__*/ React.createElement(Text, {
        align: isBrandPage ? 'center' : 'left'
    }, summary)), /*#__PURE__*/ React.createElement("article", {
        className: "content",
        id: "content-start"
    }, contentBlocks.length > 0 && /*#__PURE__*/ React.createElement(CmsContentBlocks, {
        contentBlocks: contentBlocks
    })));
};
var CmsContentLayout$1 = withEditableContent(CmsContentLayout);

export { CmsContentLayout, CmsContentLayout$1 as default };
//# sourceMappingURL=Content.js.map
